export const APP_CONFIG = {
  name: "Capital Delivery",
  version: "1.0.0",
  description: "Capital Delivery",
} as const;

export const ROUTES = {
  LOGIN: "/login",
  SIGN_UP: "/sign-up",
  RESET_PASSWORD: "/reset-password",
  ASSESSMENT: "/assessment",
  CONNECT_DEVICE: "/connect-device",
  COMPLETE: "/complete",

  DASHBOARD: "/dashboard",
  PROGRAMME_DASHBOARD: "/programme-dashboard",
  INVESTMENT_OVERSIGHT: "/investment-oversight",
  FORECAST_VARIANCE: "/forecast-variance",
  GEOSPATIAL: "/geospatial",
  GEOSPATIAL_PROJECTS: "/geospatial-projects",
  LIVE_PROGRESS: "/live-progress",

  PROJECTS: "/project",
  PORTFOLIO: "/portfolio",

  ADD_PORTFOLIO: "/portfolio/add-portfolio",
  EDIT_PORTFOLIO: "/portfolio/edit-portfolio/:portfolioId/:portfolioName",

  ADD_PROJECT: "/project/add-project",
  EDIT_PROJECT: "/project/edit-project/:projectId",

  PORTFOLIO_PROGRAMME_DASHBOARD: "/portfolio/programme-dashboard/:portfolioId/:portfolioName",
  PORTFOLIO_PROJECTS: "/portfolio/projects/:portfolioId/:portfolioName",

  // basic routes without portfolio context
  PROJECTS_DETAILS: "/project/:projectId/:projectName/:projectSection",
  PROJECTS_DETAILS_DASHBOARD: "/project/:projectId/:projectName/dashboard",
  PROJECTS_DETAILS_OVERVIEW: "/project/:projectId/:projectName/overview",
  PROJECTS_DETAILS_SCHEDULE_AND_PLANNING: "/project/:projectId/:projectName/schedule-planning",
  PROJECTS_DETAILS_STAGE_GATES: "/project/:projectId/:projectName/stage-gates",
  PROJECTS_DETAILS_RECURRING_TASKS: "/project/:projectId/:projectName/recurring-tasks",
  PROJECTS_DETAILS_TASKS: "/project/:projectId/:projectName/tasks",
  PROJECTS_DETAILS_QUERIES: "/project/:projectId/:projectName/queries",
  PROJECTS_DETAILS_COMMERICIALS: "/project/:projectId/:projectName/commercials",
  PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS: "/project/:projectId/:projectName/artefact-docs",
  PROJECTS_DETAILS_MATERIAL_REQUESTS: "/project/:projectId/:projectName/material-requests",
  PROJECTS_DETAILS_RESOURCE_REQUESTS: "/project/:projectId/:projectName/resource-requests",
  PROJECTS_DETAILS_CONFIGURAION: "/project/:projectId/:projectName/configuration",
  PROJECTS_DETAILS_ACTIVITY_LOGS: "/project/:projectId/:projectName/activity-logs",
  PROJECTS_DETAILS_RISKS_AND_ISSUES: "/project/:projectId/:projectName/risk-dashboard",

  // route with portfolio context
  PORTFOLIO_PROJECT_DETAILS: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/:projectSection",

  PORTFOLIO_PROJECTS_DETAILS_DASHBOARD: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/dashboard",
  PORTFOLIO_PROJECTS_DETAILS_OVERVIEW: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/overview",
  PORTFOLIO_PROJECTS_DETAILS_SCHEDULE_AND_PLANNING: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/schedule-planning",
  PORTFOLIO_PROJECTS_DETAILS_STAGE_GATES: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/stage-gates",
  PORTFOLIO_PROJECTS_DETAILS_RECURRING_TASKS: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/recurring-tasks",
  PORTFOLIO_PROJECTS_DETAILS_TASKS: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/tasks",
  PORTFOLIO_PROJECTS_DETAILS_QUERIES: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/queries",
  PORTFOLIO_PROJECTS_DETAILS_COMMERICIALS: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/commercials",
  PORTFOLIO_PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/artefact-docs",
  PORTFOLIO_PROJECTS_DETAILS_MATERIAL_REQUESTS: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/material-requests",
  PORTFOLIO_PROJECTS_DETAILS_RESOURCE_REQUESTS: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/resource-requests",
  PORTFOLIO_PROJECTS_DETAILS_CONFIGURAION: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/configuration",
  PORTFOLIO_PROJECTS_DETAILS_ACTIVITY_LOGS: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/activity-logs",

  PORTFOLIO_PROJECTS_DETAILS_RISKS_AND_ISSUES: "/portfolio/projects/:portfolioId/:portfolioName/:projectId/:projectName/risk-dashboard",

  RISK_DASHBOARD: "/risk-dashboard",
  COMPLIANCE: '/compliance',

  VISION_STUDIO: "/vision-studio",

  EXPORT_AND_ANALYTICS : "/export-and-analytics",
  SCHEDULED_REPORTS : "/scheduled-reports",

  TASKS: "/tasks",
  DOCUMENT_MANAGER: "/artefact-docs",
  QUERIES: "/queries",
  PORTFOLIO_SETUP: "/portfolio-setup",
  MEETING_MANAGER: "/meeting-manager",
  REQUESTS_PIPELINE: "/requests-pipeline",
  COMMERCIAL_DASHBOARD: "/commercial-dashboard",
  BUDGETS_VS_ACTUALS: "/budgets-vs-actuals",
  COMMITMENTS_AND_ACCRUALS: "/commitments-and-accruals",
  TRENDS_AND_FORECASTS: "/trends-and-forecast",
  CONTRACTOR_OVERSIGHT: "/contractor-oversight",
  ROLES: "/roles",
  INTERGRATIONS: "/integrations",
  SUPPORT: "/support",

  IMPORT_MANAGER: "/import-manager",
  IMPORT_BATCH_DETAIL: "/import-manager/batch/:batchHeaderId",

  EXPORT_MANAGER: "/export-manager",

  JEOPARDY_MANAGER: "/jeopardy-manager",
  JEOPARDY_MANAGER_DETAILS: "/jeopardy-manager/:jeopardyId/:jeopardyName",

  NOT_FOUND: "/not-found",
} as const;

export const API_ENDPOINTS = {
  BASE_URL: import.meta.env.VITE_API_URL || "http://localhost:8080",
  USERS: "/users",
  AUTH: "/auth",
} as const;
